var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon',{staticClass:"has-text-grey hover-bold",class:{ [_vm.rotationDegreesClass]: _vm.rotate, 'rotate-back': !_vm.rotate },attrs:{"icon":_vm.iconClass}})
}
var staticRenderFns = []

export { render, staticRenderFns }